import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICookiePreferences } from "../../../Orchestrator/Types/Interface/ICookiePreferences";
import { saveCookieConsent } from "../../../Lib/Utils/CookieConsentUtils";

export class AcceptAllCookiesAction extends BaseAction<void, void> {
  override async run(): Promise<void> {
    try {
      const allAcceptedPreferences: ICookiePreferences = {
        necessary: true,
        statistic: true,
        preferences: true,
        marketing: true,
      };

      saveCookieConsent(allAcceptedPreferences);
      updateRecoilState('cookieConsentGivenAtom', true);
      updateRecoilState('cookiePreferencesAtom', allAcceptedPreferences);
      updateRecoilState('cookieConsentBannerVisibleAtom', false);
      updateRecoilState('cookieManagementModalVisibleAtom', false);
    } catch (error) {
      console.error("Error in AcceptAllCookiesAction:", error);
    }
  }
} 